import { defineQuiz } from "./_schema";
import { quizV6GatedQuiz } from "./quiz-v6-gated";

/**
 * QUIZ-V6-EG-X -- tracking-isolated duplicate of the EMAIL-GATED quiz-v6 clone
 * (quiz-v6-gated, live at /pages/quiz-v6-eg) for X (Twitter) traffic.
 *
 * Analytics in this system is keyed by SLUG, not URL (admin funnel,
 * quiz_submissions.quiz_slug, Klaviyo event/profile props). X-sourced traffic
 * to the gated funnel needs to be attributable separately from every other
 * source landing on /pages/quiz-v6-eg, so we mount an identical quiz under a
 * distinct slug and publish it at /pages/quiz-v6-eg-x. Same on-screen
 * experience, separate row everywhere in our own analytics.
 *
 * Sibling of quiz-v6-x (the X duplicate of quiz-v6). Both now use the hard
 * in-loader email gate, but retain separate URLs and analytics histories.
 * Do not consolidate them.
 *
 * NAMING: the channel suffix goes on the *page-handle* stem, not the code slug
 * -- the established convention for every sibling (`quiz-v6-x` off /pages/quiz-v6,
 * `cortisol-quiz-x` off /pages/cortisol-quiz). The gated quiz's handle was
 * renamed to `quiz-v6-eg` on 2026-07-20 while its slug stayed `quiz-v6-gated`,
 * so the handle stem here is `quiz-v6-eg` and this slug is `quiz-v6-eg-x`. The
 * public URL therefore never revives the `gated` spelling the operator moved
 * off. Chosen by the operator 2026-09-02.
 *
 * This is a THIN RE-EXPORT of quiz-v6-gated: it spreads `quizV6GatedQuiz` and
 * overrides only `id` / `slug`. Everything that routes or renders --
 * `questions`, `branching`, `classifier`, `deriveProfile`, `meta`, `capture`,
 * `emailGate`, `experiment`, `variantMoves` -- is shared BY REFERENCE, so this
 * quiz can never drift from the gated parent (and, through it, from quiz-v6):
 * any future edit propagates automatically. In particular `emailGate: true` is
 * INHERITED, not restated -- if the parent's gate is ever turned off, this page
 * follows it instead of silently becoming the only gated surface left. If the
 * two are ever meant to diverge, that becomes a deliberate change (stop
 * spreading, fork the fields).
 *
 * Intelligems: NO experiment reaches this page today. It was authored on
 * 2026-09-02 inheriting MM-0093 through two hops, and MM-0093 was removed from
 * quiz-v6 hours later -- it concluded 2026-09-01 with the promoted-angle arm
 * losing (screen-1 pass 28.71% -> 20.79%), so `experiment` and `variantMoves`
 * both went away upstream and this page followed without a line changing here.
 * That is the inheritance working as designed in the disarm direction as well
 * as the arm one, and it means this page touches no `window.igData` and pays no
 * resolver poll (rule 24).
 *
 * Inheritance stays the DEFAULT for the next test, matching the decision made
 * for quiz-v6-x: the operator wants a screen-order change tested across ALL
 * traffic sources, and excluding the clones would leave them serving a
 * different screen order from their parent -- a real content divergence between
 * quizzes that are supposed to be identical. Opting this slug out of a future
 * test means adding `experiment: undefined` here.
 *
 * See docs/specs/2026-09-02-quiz-v6-eg-x-tracking-duplicate-design.md.
 */
export const quizV6EgXQuiz = defineQuiz({
  ...quizV6GatedQuiz,
  id: "quiz-v6-eg-x",
  slug: "quiz-v6-eg-x",
});
